import Message from '../message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import RedeemActions from '../../actions/RedeemActions';
import RedeemContainer from './RedeemContainer';
import SquareButton from '../squareButton/SquareButton';
import epicTracking from 'epic-tracking';

class LoginRequired extends React.Component {
  static propTypes = {
    returnPath: PropTypes.string,
    signupDisabled: PropTypes.bool,
  };

  handleLoginClick = () => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'RedeemLoginRequired',
      eventAction: 'login',
    });
    RedeemActions.requestLogin(this.props.returnPath);
  };

  handleSignupClick = () => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'RedeemLoginRequired',
      eventAction: 'signup',
    });
    RedeemActions.requestRegister(this.props.returnPath);
  };

  render() {
    let loginButtons;
    if (this.props.signupDisabled) {
      loginButtons = (
        <SquareButton
          handleClick={this.handleLoginClick}
          config={{buttonStyle: 'btn-primary', fixedWidth: true, centered: true}}>
          <Message code="epic.common.signin" />
        </SquareButton>
      );
    } else {
      loginButtons = (
        <div className="buttonContainer row">
          <div className="col-sm-6">
            <SquareButton
              handleClick={this.handleSignupClick}
              config={{buttonStyle: 'btn-default', inline: true, fixedWidth: true}}>
              <Message code="epic.common.signup" />
            </SquareButton>
          </div>
          <div className="col-sm-6">
            <SquareButton
              handleClick={this.handleLoginClick}
              config={{buttonStyle: 'btn-primary', inline: true, fixedWidth: true}}>
              <Message code="epic.common.signin" />
            </SquareButton>
          </div>
        </div>
      );
    }
    return (
      <div className="loginRequired">
        <RedeemContainer className="redeemContainer">
          <h1 className="site-block-page-title">
            <Message code="epic.code.redemption.login.title" />
          </h1>
          <div className="site-block">
            <div className="site-block-header">
              <h1 className="site-block-title">
                <Message code="epic.code.redemption.login.subtitle" />
              </h1>
              <div className="clearfix" />
            </div>
            <p>
              <Message code="epic.code.redemption.login.msg" />
            </p>
            {loginButtons}
          </div>
        </RedeemContainer>
      </div>
    );
  }
}

export default LoginRequired;
